import React, { ReactNode } from 'react';

export function injectPropsToChildren<P>(children: ReactNode, props: Partial<P>): ReactNode {
  return React.Children.map(children, (child) => {
    if (React.isValidElement<P>(child)) {
      return React.cloneElement(child, props);
    }
    return child;
  });
}
